import { render } from "./ticketRicevuto.vue?vue&type=template&id=4c1a8619&ts=true"
import script from "./ticketRicevuto.vue?vue&type=script&lang=ts"
export * from "./ticketRicevuto.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__